import Log from "./Log";

export const downloadBuildboxClient = () => {
  // try to auto detect platform from browser
  const platform = window.navigator.platform;

  if (platform) {
    const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
    const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
    Log.info("Detected platform(s):", platform);

    const foundMatch = (str) => str.includes(platform);
    if (windowsPlatforms.some(foundMatch)) {
      const downloadLink = process.env.REACT_APP_BB3_DOWNLOAD_LINK_WIN;
      return downloadLink;
    } else if (macosPlatforms.some(foundMatch)) {
      const downloadLink = process.env.REACT_APP_BB3_DOWNLOAD_LINK_MAC;
      return downloadLink;
    } else {
      Log.warn("unable to automatically determine download platform from ");
    }
  } else {
    Log.warn("unable to automatically determine download platform");
    return "";
  }
};
